import {createReducer, on} from '@ngrx/store';
import {ApplicationAppEntityApplicationRead, EntityTypeAppEntityDictionaryEntityType} from '../../openapi';
import {
  approveApplication,
  approveApplicationFailure,
  approveApplicationSuccess,
  createApplication,
  createApplicationFailure,
  createApplicationSuccess,
  fakeSignApplication,
  fakeSignApplicationFailure,
  fakeSignApplicationSuccess,
  loadApplication,
  loadApplicationFailure,
  loadApplicationList,
  loadApplicationListFailure,
  loadApplicationListSuccess,
  loadApplicationSuccess,
  loadPayments,
  loadPaymentsFailure,
  loadPaymentsSuccess,
  loadServiceAttachmentPositions,
  loadServiceAttachmentPositionsFailure,
  loadServiceAttachmentPositionsSuccess,
  sendApplication,
  sendApplicationFailure,
  sendApplicationSuccess,
  setApplication,
  setPayments,
  signApplication,
  signApplicationFailure,
  signApplicationSuccess,
  updateApplicantData,
  updateApplicantDataFailure,
  updateApplicantDataSuccess,
  updateApplication,
  updateApplicationAttachments,
  updateApplicationAttachmentsFailure,
  updateApplicationAttachmentsSuccess,
  updateApplicationFailure,
  updateApplicationSuccess,
  updateContractors,
  updateContractorsFailure,
  updateContractorsSuccess,
  updateInvestorRepresentatives,
  updateInvestorRepresentativesFailure,
  updateInvestorRepresentativesSuccess,
  updateParcels,
  updateParcelsFailure,
  updateParcelsSuccess,
  updateTaxObjectsData,
  updateTaxObjectsDataFailure,
  updateTaxObjectsDataSuccess
} from '../actions/application.actions';
import {ApplicationListItem, ApplicationPayment, AttachmentPositions} from '../../services/application.common.model';

export interface ApplicationState {
  loading: number;
  pending: number;
  application: ApplicationAppEntityApplicationRead | null;
  applicationPayment: ApplicationPayment | null;
  applicationList: ApplicationListItem[];
  entityTypes: EntityTypeAppEntityDictionaryEntityType[];
  serviceAttachmentPositions: AttachmentPositions;
}

export const initialApplicationState: ApplicationState = {
  pending: 0,
  loading: 0,
  application: null,
  applicationPayment: null,
  applicationList: [],
  entityTypes: [],
  serviceAttachmentPositions: []
};

export const applicationReducer = createReducer(
  initialApplicationState,
  on(createApplication, state => ({...state, pending: state.pending + 1})),
  on(createApplicationSuccess, (state, action) => ({
    ...state,
    application: action.application,
    pending: state.pending - 1
  })),
  on(createApplicationFailure, state => ({...state, pending: state.pending - 1})),

  on(setApplication, (state, action) => ({...state, application: action.application})),

  on(loadApplication, state => ({...state, loading: state.loading + 1})),
  on(loadApplicationSuccess, (state, action) => ({
    ...state,
    loading: state.loading - 1,
    application: action.application
  })),
  on(loadApplicationFailure, state => ({...state, loading: state.loading - 1})),

  on(updateApplication, state => ({...state, pending: state.pending + 1})),
  on(updateApplicationSuccess, (state, action) => ({
    ...state,
    pending: state.pending - 1,
    application: action.application
  })),
  on(updateApplicationFailure, state => ({...state, pending: state.pending - 1})),

  on(updateApplicantData, state => ({...state, pending: state.pending + 1})),
  on(updateApplicantDataSuccess, (state, action) => ({
    ...state,
    application: action.application,
    pending: state.pending - 1
  })),
  on(updateApplicantDataFailure, state => ({...state, pending: state.pending - 1})),

  on(updateContractors, state => ({...state, pending: state.pending + 1})),
  on(updateContractorsSuccess, (state, action) => ({
    ...state,
    application: action.application,
    pending: state.pending - 1
  })),
  on(updateContractorsFailure, state => ({...state, pending: state.pending - 1})),

  on(updateApplicationAttachments, state => ({...state, pending: state.pending + 1})),
  on(updateApplicationAttachmentsSuccess, (state, action) => ({
    ...state,
    application: action.application,
    pending: state.pending - 1
  })),
  on(updateApplicationAttachmentsFailure, state => ({...state, pending: state.pending - 1})),

  on(approveApplication, state => ({...state, pending: state.pending + 1})),
  on(approveApplicationSuccess, (state, action) => ({
    ...state,
    application: action.application,
    pending: state.pending - 1
  })),
  on(approveApplicationFailure, state => ({...state, pending: state.pending - 1})),

  on(loadApplicationList, state => ({...state, loading: state.loading + 1})),
  on(loadApplicationListSuccess, (state, action) => ({
    ...state,
    loading: state.loading - 1,
    applicationList: action.applicationList
  })),
  on(loadApplicationListFailure, (state) => ({...state, loading: state.loading - 1})),

  on(setPayments, (state, action) => ({...state, applicationPayment: action.applicationPayment})),

  on(loadPayments, state => ({...state, loading: state.loading + 1})),
  on(loadPaymentsSuccess, (state, action) => ({
      ...state,
      applicationPayment: action.applicationPayment,
      loading: state.loading - 1
    })
  ),
  on(loadPaymentsFailure, state => ({...state, loading: state.loading - 1})),

  on(sendApplication, state => ({...state, pending: state.pending + 1})),
  on(sendApplicationSuccess, state => ({...state, pending: state.pending - 1})),
  on(sendApplicationFailure, state => ({...state, pending: state.pending - 1})),

  on(signApplication, state => ({...state, pending: state.pending + 1})),
  on(signApplicationSuccess, state => ({...state, pending: state.pending - 1})),
  on(signApplicationFailure, state => ({...state, pending: state.pending - 1})),

  on(updateInvestorRepresentatives, state => ({...state, pending: state.pending + 1})),
  on(updateInvestorRepresentativesSuccess, (state, action) => ({
    ...state,
    pending: state.pending - 1,
    application: action.application
  })),
  on(updateInvestorRepresentativesFailure, (state, action) => ({...state, pending: state.pending - 1})),

  on(updateTaxObjectsData, state => ({...state, pending: state.pending + 1})),
  on(updateTaxObjectsDataSuccess, (state, action) => ({
    ...state,
    pending: state.pending - 1,
    application: action.application
  })),
  on(updateTaxObjectsDataFailure, state => ({...state, pending: state.pending - 1})),

  on(fakeSignApplication, state => ({...state, pending: state.pending + 1})),
  on(fakeSignApplicationSuccess, (state, action) => ({
    ...state,
    pending: state.pending - 1
  })),
  on(fakeSignApplicationFailure, state => ({...state, pending: state.pending - 1})),

  on(loadServiceAttachmentPositions, state => ({...state, loading: state.loading + 1})),
  on(loadServiceAttachmentPositionsSuccess, (state, action) => ({
    ...state,
    loading: state.loading - 1,
    serviceAttachmentPositions: action.serviceAttachmentPositions
  })),
  on(loadServiceAttachmentPositionsFailure, state => ({...state, loading: state.loading - 1})),

  on(updateParcels, state => ({...state, pending: state.pending + 1})),
  on(updateParcelsSuccess, (state, action) => ({
    ...state,
    application: action.application,
    pending: state.pending - 1
  })),
  on(updateParcelsFailure, state => ({...state, pending: state.pending - 1})),
);
